module.exports = __webpack_public_path__ + "2ff84c94e4f42336b9da8b097d98a64f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-20.png
// module id = 3066
// module chunks = 0